<template>
<div class="TTL-el-form-search-regular">
    <el-form inline="true">
        <el-form-item>
            <wcselect :option="{placeholder:'请选择时间类型',ischange:true,width:'170px',}" 
                :value="param.timetype"
                :list="timetypelist"
                @finish="(val)=> {
                    param.timetype=val.value;
                    param.time=[];
                    param.begin='';
                    param.end='';
                    param.ischange=true;
                    if(val.value==1) {
                        param.type='date';
                        param.timeformat='YYYY-MM-DD';
                        param.begin=$method.GetBeforeTimes(1,7);
                        param.end=$method.GetNowTimes(1);
                    }else if(val.value==2) {
                        param.type='month';
                        param.timeformat='YYYY-MM';
                        param.begin=$method.GetBeforeTimes(2,6);
                        param.end=$method.GetNowTimes(2);
                    }else if(val.value==3) {
                        param.type='year';
                        param.timeformat='YYYY';
                        param.begin=$method.GetBeforeTimes(3,3);
                        param.end=$method.GetNowTimes(3);
                    }
                }"
            />
        </el-form-item>
        <el-form-item>
            <wctime :option="{placeholder:'开始时间',type:param.type,format:param.timeformat,width:'170px',ischange:true,clearable:false}"
                :value="param.begin"
                @finish="(val)=> {
                    param.begin=val.value;
                    param.ischange=true;
                }"
            />
        </el-form-item>
        <el-form-item>
            <wctime :option="{placeholder:'结束时间',type:param.type,format:param.timeformat,width:'170px',ischange:true,clearable:false}"
                :value="param.end"
                @finish="(val)=> {
                    param.end=val.value;
                    param.ischange=true;
                }"
            />
        </el-form-item>
        <el-form-item v-if="!param.isorder">
            <wcselect :option="{placeholder:'商品分类',ischange:true,width:'170px',clearable:true,filterable:true}" 
                :value="param.pcateid"
                :list="pcatelists"
                @finish="(val)=> {
                    param.pcateid=val.value;
                    param.ischange=true;
                    changeCateinfo();
                    GetList();
                }"
            />
        </el-form-item>
        <el-form-item v-if="!param.isorder">
            <wcselect :option="{placeholder:'商品二级分类',ischange:true,width:'170px',clearable:true,filterable:true}" 
                :value="param.cateid"
                :list="scatelists"
                @finish="(val)=> {
                    param.cateid=val.value;
                    param.ischange=true;
                    GetList();
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcbutton :option="{title:'搜索'}" @finish="GetList"/>
        </el-form-item>
        <el-form-item style="position:absolute;right:0;">
        <div class="TTL-switch" style="display:inline-flex;align-items:center;height:60px;">
        <el-switch v-model="param.isorder" active-text="查看趋势图、分布图" 
            @change="(val)=>{
                param.timetype=1;
                param.type='date';
                param.timeformat='YYYY-MM-DD';
                param.begin=$method.GetBeforeTimes(1,7);
                param.end=$method.GetNowTimes(1);
                param.pcateid='';
                param.cateid='';
                this.param.change=true;
                GetList();
            }" 
        />
        </div>
        </el-form-item>
    </el-form>
</div>


<!-- 一级数据操作 -->
<div v-if="!param.isorder">
<div class="TTL-table top20" :ref="objloading">
    <el-table :data="list" stripe="true" empty-text="" >
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column prop="time" label="时间" align="center" fixed="left" />
        <el-table-column prop="catename" label="分类名称" align="center" fixed="left" />
        <el-table-column prop="goodsnums" label="数据发布量" align="center" fixed="left" />
        <el-table-column prop="salenums" label="发布闲置" align="center" fixed="left" />
        <el-table-column prop="person_nums" label="个人发布量" align="center" fixed="left" />
        <el-table-column prop="person_sale_nums" label="个人闲置" align="center" fixed="left" />
        <el-table-column prop="person_buy_nums" label="个人求购" align="center" fixed="left" />
        <el-table-column prop="compony_nums" label="企业发布量" align="center" fixed="left" />
        <el-table-column prop="compony_sale_nums" label="企业闲置" align="center" fixed="left" />
        <el-table-column prop="compony_buy_nums" label="企业求购" align="center" fixed="left" />
    </el-table>
</div>
<div class="TTL-page-box top20">
    <div class="TTL-page-box-in">
        <div class="TTL-page TTL-page-right">
            <wcpage :row="param.rows" :p="param.p" :rollpage="param.rollpage"
                @finish="(val)=> {
                    param.p=val.p;
                    param.rollpage=val.rollpage;
                    GetList();
                }"
            />
        </div>
    </div>
</div>
</div>


<!-- 图形操作 -->
<div class="TTL-pies" v-if="param.isorder" :ref="objloading">
    <div class="TTL-pie-main top20">
        <div class="TTL-pie-infos">
            <span class="TTL-pie-title">数据总数量趋势图</span>
            <div class="TTL-pie-infos-tu" :ref="goodsnumsObj.ref" />
        </div>
        <div class="TTL-pie-area">
            <span class="TTL-pie-title">数据总数量分布图</span>
            <div class="TTL-pie-infos-tu" :ref="goodsnnumsareaObj.ref" />
        </div>
    </div>
    <div class="TTL-pie-main top40">
        <div class="TTL-pie-infos">
            <span class="TTL-pie-title">闲置数据总数量趋势图</span>
            <div class="TTL-pie-infos-tu" :ref="salenumsObj.ref" />
        </div>
        <div class="TTL-pie-area">
            <span class="TTL-pie-title">闲置数据总数量分布图</span>
            <div class="TTL-pie-infos-tu" :ref="salenumsareaObj.ref" />
        </div>
    </div>
    <div class="TTL-pie-main top40">
        <div class="TTL-pie-infos">
            <span class="TTL-pie-title">求购数据总数量趋势图</span>
            <div class="TTL-pie-infos-tu" :ref="buynnumsObj.ref" />
        </div>
        <div class="TTL-pie-area">
            <span class="TTL-pie-title">求购数据总数量分布图</span>
            <div class="TTL-pie-infos-tu" :ref="buynnumsareaObj.ref" />
        </div>
    </div>
    <div class="TTL-pie-main top40">
        <div class="TTL-pie-infos">
            <span class="TTL-pie-title">个人发布数据趋势图</span>
            <div class="TTL-pie-infos-tu" :ref="person_numsObj.ref" />
        </div>
        <div class="TTL-pie-area">
            <span class="TTL-pie-title">个人发布数据分布图</span>
            <div class="TTL-pie-infos-tu" :ref="person_numsareaObj.ref" />
        </div>
    </div>
    <div class="TTL-pie-main top40">
        <div class="TTL-pie-infos">
            <span class="TTL-pie-title">个人闲置发布数据趋势图</span>
            <div class="TTL-pie-infos-tu" :ref="person_sale_numsObj.ref" />
        </div>
        <div class="TTL-pie-area">
            <span class="TTL-pie-title">个人闲置发布数据分布图</span>
            <div class="TTL-pie-infos-tu" :ref="person_sale_numsareaObj.ref" />
        </div>
    </div>
    <div class="TTL-pie-main top40">
        <div class="TTL-pie-infos">
            <span class="TTL-pie-title">个人求购发布数据趋势图</span>
            <div class="TTL-pie-infos-tu" :ref="person_buy_numsObj.ref" />
        </div>
        <div class="TTL-pie-area">
            <span class="TTL-pie-title">个人求购发布数据分布图</span>
            <div class="TTL-pie-infos-tu" :ref="person_buy_numsareaObj.ref" />
        </div>
    </div>
    <div class="TTL-pie-main top40">
        <div class="TTL-pie-infos">
            <span class="TTL-pie-title">企业发布数据趋势图</span>
            <div class="TTL-pie-infos-tu" :ref="compony_numsObj.ref" />
        </div>
        <div class="TTL-pie-area">
            <span class="TTL-pie-title">企业发布数据分布图</span>
            <div class="TTL-pie-infos-tu" :ref="compony_numsareaObj.ref" />
        </div>
    </div>
    <div class="TTL-pie-main top40">
        <div class="TTL-pie-infos">
            <span class="TTL-pie-title">企业闲置数据趋势图</span>
            <div class="TTL-pie-infos-tu" :ref="compony_sale_numsObj.ref" />
        </div>
        <div class="TTL-pie-area">
            <span class="TTL-pie-title">企业闲置数据分布图</span>
            <div class="TTL-pie-infos-tu" :ref="compony_sale_numsareaObj.ref" />
        </div>
    </div>
    <div class="TTL-pie-main top40">
        <div class="TTL-pie-infos">
            <span class="TTL-pie-title">企业求购数据趋势图</span>
            <div class="TTL-pie-infos-tu" :ref="compony_buy_numsObj.ref" />
        </div>
        <div class="TTL-pie-area">
            <span class="TTL-pie-title">企业求购数据分布图</span>
            <div class="TTL-pie-infos-tu" :ref="compony_buy_numsareaObj.ref" />
        </div>
    </div>
</div> 


</template>

<script>
import INTERFACE_MODEL_STAT from '@/Interface/Es/stat';
import * as echarts from 'echarts';
export default {

    components:{
        
    },

    data() {
        return {
            objloading:'CateStat',
            param: {
                isorder:false,
                timetype:1,
                type:'date',
                timeformat:'YYYY-MM-DD',
                begin:this.$method.GetBeforeTimes(1,7),
                end:this.$method.GetNowTimes(1),
                pcateid:'',
                cateid:'',
                p:1,
                rollpage:10,
                ischange:false,
                rows:0,
            },
            timetypelist:[
                {id:1,name:'按日期搜索'},
                {id:2,name:'按月份搜索'},
                {id:3,name:'按年份搜索'},
            ],
            pcatelists:[],
            basecatelists:[],
            scatelists:[],
            list:[],
            listpie:{},

            //发布总量
            goodsnumsObj: {
                ref:'goodsnumsobj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#666eeb'
                        }
                    }]
                },
            },
            //发布总量分布图
            goodsnnumsareaObj: {
                ref:'goodsnnumsareaObj',
                option: {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    series: [
                        {
                            name: '发布总量分布图',
                            type: 'pie',
                            radius: ['40%', '60%'],
                            center: ['50%', '50%'],
                            roseType: 'area',
                            itemStyle: {
                                borderRadius: 5
                            },
                            data: []
                        }
                    ]
                }
            },

            //发布闲置总量
            salenumsObj: {
                ref:'salenumsObj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#d8a51c'
                        }
                    }]
                },
            },
            //发布闲置总量趋势图
            salenumsareaObj: {
                ref:'salenumsareaObj',
                option: {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    series: [
                        {
                            name: '闲置发布总量分布图',
                            type: 'pie',
                            radius: ['40%', '60%'],
                            center: ['50%', '50%'],
                            roseType: 'area',
                            itemStyle: {
                                borderRadius: 5
                            },
                            data: []
                        }
                    ]
                }
            },

            //发布求购总量
            buynnumsObj: {
                ref:'buynnumsObj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#d8a51c'
                        }
                    }]
                },
            },
            //发布求购总量趋势图
            buynnumsareaObj: {
                ref:'buynnumsareaObj',
                option: {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    series: [
                        {
                            name: '求购发布总量分布图',
                            type: 'pie',
                            radius: ['40%', '60%'],
                            center: ['50%', '50%'],
                            roseType: 'area',
                            itemStyle: {
                                borderRadius: 5
                            },
                            data: []
                        }
                    ]
                }
            },

            //个人发布求购总量
            person_numsObj: {
                ref:'person_numsObj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#d8a51c'
                        }
                    }]
                },
            },
            //个人发布求购总量趋势图
            person_numsareaObj: {
                ref:'person_numsareaObj',
                option: {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    series: [
                        {
                            name: '个人发布分布图',
                            type: 'pie',
                            radius: ['40%', '60%'],
                            center: ['50%', '50%'],
                            roseType: 'area',
                            itemStyle: {
                                borderRadius: 5
                            },
                            data: []
                        }
                    ]
                }
            },

            //个人发布闲置总量
            person_sale_numsObj: {
                ref:'person_sale_numsObj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#d8a51c'
                        }
                    }]
                },
            },
            //个人发布闲置总量趋势图
            person_sale_numsareaObj: {
                ref:'person_sale_numsareaObj',
                option: {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    series: [
                        {
                            name: '个人闲置发布分布图',
                            type: 'pie',
                            radius: ['40%', '60%'],
                            center: ['50%', '50%'],
                            roseType: 'area',
                            itemStyle: {
                                borderRadius: 5
                            },
                            data: []
                        }
                    ]
                }
            },

            //个人发布求购总量
            person_buy_numsObj: {
                ref:'person_buy_numsObj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#d8a51c'
                        }
                    }]
                },
            },
            //个人发布求购总量趋势图
            person_buy_numsareaObj: {
                ref:'person_buy_numsareaObj',
                option: {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    series: [
                        {
                            name: '个人求购发布分布图',
                            type: 'pie',
                            radius: ['40%', '60%'],
                            center: ['50%', '50%'],
                            roseType: 'area',
                            itemStyle: {
                                borderRadius: 5
                            },
                            data: []
                        }
                    ]
                }
            },

            //企业发布总量
            compony_numsObj: {
                ref:'compony_numsObj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#d8a51c'
                        }
                    }]
                },
            },
            //企业发布总量趋势图
            compony_numsareaObj: {
                ref:'compony_numsareaObj',
                option: {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    series: [
                        {
                            name: '企业发布分布图',
                            type: 'pie',
                            radius: ['40%', '60%'],
                            center: ['50%', '50%'],
                            roseType: 'area',
                            itemStyle: {
                                borderRadius: 5
                            },
                            data: []
                        }
                    ]
                }
            },

            //企业闲置总量
            compony_sale_numsObj: {
                ref:'compony_sale_numsObj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#d8a51c'
                        }
                    }]
                },
            },
            //企业发布总量趋势图
            compony_sale_numsareaObj: {
                ref:'compony_sale_numsareaObj',
                option: {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    series: [
                        {
                            name: '企业闲置分布图',
                            type: 'pie',
                            radius: ['40%', '60%'],
                            center: ['50%', '50%'],
                            roseType: 'area',
                            itemStyle: {
                                borderRadius: 5
                            },
                            data: []
                        }
                    ]
                }
            },

            //企业求购总量
            compony_buy_numsObj: {
                ref:'compony_buy_numsObj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#d8a51c'
                        }
                    }]
                },
            },
            //企业求购总量趋势图
            compony_buy_numsareaObj: {
                ref:'compony_buy_numsareaObj',
                option: {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    series: [
                        {
                            name: '企业求购分布图',
                            type: 'pie',
                            radius: ['40%', '60%'],
                            center: ['50%', '50%'],
                            roseType: 'area',
                            itemStyle: {
                                borderRadius: 5
                            },
                            data: []
                        }
                    ]
                }
            },


        }
    },

    mounted() {
        this.OnloadMethod(false); //页数初始化

    },

    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetList();
            this.GetPcates(isfresh); //获取所有一级分类
            this.GetScates(isfresh); //获取所有二级分类
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) { //组件已存在，同级兄弟元素调用时产生的操作
                this.GetList();
            }else if(data.reload) { //浏览器重新刷新时执行的操作
                
            }else {
                this.GetList();
            }
        },


        /** 获取全部一级分类 **/
        GetPcates(isfresh) {
             this.$method.GET_CATES_PARENT(isfresh).then((res) => {this.pcatelists=res;console.log(res)});
        },


        /** 获取全部二级分类 **/
        GetScates(isfresh) {
            this.$method.GET_CATES_CHILD(isfresh).then((res) => {this.basecatelists=res;console.log(res)});
        },


        /** 刷新二级分类信息 **/
        changeCateinfo() {
            this.param.cateid='';
            this.scatelists=[];
            var pcateid=this.param.pcateid;
            var basecatelists=this.basecatelists;
            for(var i=0;i < basecatelists.length; i++) {
                if(pcateid==basecatelists[i].pid) 
                this.scatelists.push(basecatelists[i]);
            }
        },


        /** 列表数据搜索 **/
        GetList() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            var obj=this.$refs[this.objloading];
            this.$loading.openloading(obj);
            var METHOD=!this.param.isorder ? 'GET_CATE_STAT_DATE' : 'GET_CATE_STAT_DATE_PIE';
            INTERFACE_MODEL_STAT[METHOD](this.param).then((res) => {
                 this.$loading.closeloading(obj);
                 if(res.status > 0) return false;
                 this.param.rows=res.data.count;
                 !this.param.isorder ? this.list=res.data.list : this.listpie=res.data.list;
                 //更新图形数据
                 if(this.param.isorder) this.updatePies();
            });
        },


        /** 加载图形数据 **/
        updatePies() {
            //总发布数据量
            this.goodsnumsObj.option.xAxis.data=this.listpie.bar.goodsnums.time;
            this.goodsnumsObj.option.series[0].data=this.listpie.bar.goodsnums.data;
            var goodsnumDom = this.$refs[this.goodsnumsObj.ref];
            var goodsnumChart = echarts.init(goodsnumDom);
            goodsnumChart.setOption(this.goodsnumsObj.option);
            //总发布数量分布图
            this.goodsnnumsareaObj.option.series[0].data=this.listpie.bar.goodsnums.area ? this.listpie.bar.goodsnums.area : [];
            var goodsnumareaDom = this.$refs[this.goodsnnumsareaObj.ref];
            var goodsnumareaChart = echarts.init(goodsnumareaDom);
            goodsnumareaChart.setOption(this.goodsnnumsareaObj.option);

            //闲置总发布数据量
            this.salenumsObj.option.xAxis.data=this.listpie.bar.salenums.time;
            this.salenumsObj.option.series[0].data=this.listpie.bar.salenums.data;
            var salenumsDom = this.$refs[this.salenumsObj.ref];
            var salenumsChart = echarts.init(salenumsDom);
            salenumsChart.setOption(this.salenumsObj.option);
            //闲置总发布数量分布图
            this.salenumsareaObj.option.series[0].data=this.listpie.bar.salenums.area ? this.listpie.bar.salenums.area : [];
            var salenumsareaDom = this.$refs[this.salenumsareaObj.ref];
            var salenumsareaChart = echarts.init(salenumsareaDom);
            salenumsareaChart.setOption(this.salenumsareaObj.option);

            //求购总发布数据量
            this.buynnumsObj.option.xAxis.data=this.listpie.bar.buynnums.time;
            this.buynnumsObj.option.series[0].data=this.listpie.bar.buynnums.data;
            var buynnumsDom = this.$refs[this.buynnumsObj.ref];
            var buynnumsChart = echarts.init(buynnumsDom);
            buynnumsChart.setOption(this.buynnumsObj.option);
            //求购总发布数量分布图
            this.buynnumsareaObj.option.series[0].data=this.listpie.bar.buynnums.area ? this.listpie.bar.buynnums.area : [];
            var buynnumsareaDom = this.$refs[this.buynnumsareaObj.ref];
            var buynnumsareaChart = echarts.init(buynnumsareaDom);
            buynnumsareaChart.setOption(this.buynnumsareaObj.option);

            //个人发布数据量
            this.person_numsObj.option.xAxis.data=this.listpie.bar.person_nums.time;
            this.person_numsObj.option.series[0].data=this.listpie.bar.person_nums.data;
            var person_numsDom = this.$refs[this.person_numsObj.ref];
            var person_numsChart = echarts.init(person_numsDom);
            person_numsChart.setOption(this.person_numsObj.option);
            //个人发布数量分布图
            this.person_numsareaObj.option.series[0].data=this.listpie.bar.person_nums.area ? this.listpie.bar.person_nums.area : [];
            var person_numsareaDom = this.$refs[this.person_numsareaObj.ref];
            var person_numsareaChart = echarts.init(person_numsareaDom);
            person_numsareaChart.setOption(this.person_numsareaObj.option);

            //个人闲置发布数据量
            this.person_sale_numsObj.option.xAxis.data=this.listpie.bar.person_sale_nums.time;
            this.person_sale_numsObj.option.series[0].data=this.listpie.bar.person_sale_nums.data;
            var person_sale_numsDom = this.$refs[this.person_sale_numsObj.ref];
            var person_sale_numsChart = echarts.init(person_sale_numsDom);
            person_sale_numsChart.setOption(this.person_sale_numsObj.option);
            //个人闲置发布数量分布图
            this.person_sale_numsareaObj.option.series[0].data=this.listpie.bar.person_sale_nums.area ? this.listpie.bar.person_sale_nums.area : [];
            var person_sale_numsareaDom = this.$refs[this.person_sale_numsareaObj.ref];
            var person_sale_numsareaChart = echarts.init(person_sale_numsareaDom);
            person_sale_numsareaChart.setOption(this.person_sale_numsareaObj.option);

            //个人求购发布数据量
            this.person_buy_numsObj.option.xAxis.data=this.listpie.bar.person_buy_nums.time;
            this.person_buy_numsObj.option.series[0].data=this.listpie.bar.person_buy_nums.data;
            var person_buy_numsDom = this.$refs[this.person_buy_numsObj.ref];
            var person_buy_numsChart = echarts.init(person_buy_numsDom);
            person_buy_numsChart.setOption(this.person_buy_numsObj.option);
            //个人求购发布数量分布图
            this.person_buy_numsareaObj.option.series[0].data=this.listpie.bar.person_buy_nums.area ? this.listpie.bar.person_buy_nums.area : [];
            var person_buy_numsareaDom = this.$refs[this.person_buy_numsareaObj.ref];
            var person_buy_numsareaChart = echarts.init(person_buy_numsareaDom);
            person_buy_numsareaChart.setOption(this.person_buy_numsareaObj.option);

            //企业发布数据量
            this.compony_numsObj.option.xAxis.data=this.listpie.bar.compony_nums.time;
            this.compony_numsObj.option.series[0].data=this.listpie.bar.compony_nums.data;
            var compony_numsObjDom = this.$refs[this.compony_numsObj.ref];
            var compony_numsObjChart = echarts.init(compony_numsObjDom);
            compony_numsObjChart.setOption(this.compony_numsObj.option);
            //企业发布数量分布图
            this.compony_numsareaObj.option.series[0].data=this.listpie.bar.compony_nums.area ? this.listpie.bar.compony_nums.area : [];
            var compony_numsareaDom = this.$refs[this.compony_numsareaObj.ref];
            var compony_numsareaChart = echarts.init(compony_numsareaDom);
            compony_numsareaChart.setOption(this.compony_numsareaObj.option);

            //企业闲置发布数据量
            this.compony_sale_numsObj.option.xAxis.data=this.listpie.bar.compony_sale_nums.time;
            this.compony_sale_numsObj.option.series[0].data=this.listpie.bar.compony_sale_nums.data;
            var compony_sale_numsDom = this.$refs[this.compony_sale_numsObj.ref];
            var compony_sale_numsChart = echarts.init(compony_sale_numsDom);
            compony_sale_numsChart.setOption(this.compony_sale_numsObj.option);
            //企业闲置发布数量分布图
            this.compony_sale_numsareaObj.option.series[0].data=this.listpie.bar.compony_sale_nums.area ? this.listpie.bar.compony_sale_nums.area : [];
            var compony_sale_numsareaDom = this.$refs[this.compony_sale_numsareaObj.ref];
            var compony_sale_numsareaChart = echarts.init(compony_sale_numsareaDom);
            compony_sale_numsareaChart.setOption(this.compony_sale_numsareaObj.option);

            //企业求购发布数据量
            this.compony_buy_numsObj.option.xAxis.data=this.listpie.bar.compony_buy_nums.time;
            this.compony_buy_numsObj.option.series[0].data=this.listpie.bar.compony_buy_nums.data;
            var compony_buy_numsDom = this.$refs[this.compony_buy_numsObj.ref];
            var compony_buy_numsChart = echarts.init(compony_buy_numsDom);
            compony_buy_numsChart.setOption(this.compony_buy_numsObj.option);
            //企业求购发布数量分布图
            this.compony_buy_numsareaObj.option.series[0].data=this.listpie.bar.compony_buy_nums.area ? this.listpie.bar.compony_buy_nums.area : [];
            var compony_buy_numsareaDom = this.$refs[this.compony_buy_numsareaObj.ref];
            var compony_buy_numsareaChart = echarts.init(compony_buy_numsareaDom);
            compony_buy_numsareaChart.setOption(this.compony_buy_numsareaObj.option);
        },


    },
}
</script>
<style scoped>
::v-deep(.TTL-switch .el-switch__label *) {font-size:13px;color:#666666;letter-spacing: 1px;}
.TTL-btn-info {display:inline-flex;}
.ttl-frozen {display: inline-flex;justify-content: center;align-items: center;width:100% !important;}
.ttl-frozen .el-image{display: inline-block;width:25px;height:25px;margin-right:5px;}
.TTL-pie-main {display: inline-flex;width:100%;align-items: center;}
.TTL-pie-infos {width:65%;overflow-x: auto;}
.TTL-pie-infos-tu {display: inline-block;width:100%;height:300px;}
.TTL-pie-title {font-size:13px;color:#503b11;display: inline-block;width:100%;text-align: center;}
.TTL-pie-area {width:35%;text-align: center;}
.TTL-pies {display: inline-block;width:100%}
</style>